import type {
  TerminalDiagnostic,
  TerminalDiagnosticCode,
} from "@/client/types";

type DiagnosticCopy = {
  title: string;
  message: string;
  action: string;
};

const copyByCode: Record<TerminalDiagnosticCode, DiagnosticCopy> = {
  online: {
    title: "Terminal erreichbar",
    message: "Adyen bestätigt eine aktive Cloud-Verbindung zum Terminal.",
    action: "Keine Aktion erforderlich.",
  },
  offline: {
    title: "Terminal offline",
    message:
      "Adyen kennt das Terminal, meldet aber keine aktive Cloud-Verbindung.",
    action:
      "Terminal einschalten und unter Einstellungen → Diagnose die WebSocket-Verbindung prüfen.",
  },
  invalid_credentials: {
    title: "API-Schlüssel abgelehnt",
    message: "Adyen hat den API-Schlüssel nicht akzeptiert.",
    action: "Prüfe, ob Test-/Live-Umgebung und API-Schlüssel zusammengehören.",
  },
  insufficient_permissions: {
    title: "Berechtigung fehlt",
    message: "Der API-Schlüssel darf den Terminalstatus nicht abfragen.",
    action:
      "Aktiviere für die API-Credential die Rolle „Cloud Device API“ und den richtigen Merchant Account.",
  },
  terminal_not_found: {
    title: "Terminal nicht gefunden",
    message: "Adyen konnte Terminal und Merchant Account nicht zusammenführen.",
    action:
      "Prüfe POIID, Merchant Account und die Zuweisung des Terminals zu Merchant oder Store.",
  },
  rate_limited: {
    title: "Zu viele Anfragen",
    message: "Adyen hat die Statusabfrage vorübergehend begrenzt.",
    action: "Warte kurz und starte den Terminaltest anschließend erneut.",
  },
  adyen_unavailable: {
    title: "Adyen nicht verfügbar",
    message: "Adyen hat die Statusabfrage mit einem Serverfehler beantwortet.",
    action:
      "Versuche es später erneut und verwende bei einer Supportanfrage die angezeigten Request-IDs.",
  },
  adyen_error: {
    title: "Adyen-Anfrage fehlgeschlagen",
    message: "Adyen hat die Statusabfrage abgelehnt.",
    action:
      "Prüfe die technischen Details und die Terminalkonfiguration im Adyen Customer Area.",
  },
  invalid_response: {
    title: "Ungültige Adyen-Antwort",
    message:
      "Der Worker konnte die Statusantwort von Adyen nicht sicher auswerten.",
    action:
      "Suche in den Worker-Logs nach der angezeigten Request-ID und teste erneut.",
  },
  network_error: {
    title: "Netzwerkfehler",
    message:
      "Der Worker konnte Adyen nicht innerhalb des Zeitlimits erreichen.",
    action:
      "Prüfe den Adyen-Status und starte den Test erneut. Keine Auszahlung blind wiederholen.",
  },
};

export function terminalDiagnosticCopy(
  diagnostic: TerminalDiagnostic,
): DiagnosticCopy {
  return copyByCode[diagnostic.code];
}

export function terminalDiagnosticDetails(
  diagnostic: TerminalDiagnostic,
): string[] {
  return [
    `Worker-Request-ID: ${diagnostic.requestId}`,
    ...(diagnostic.adyenStatus
      ? [`Adyen-Status: ${diagnostic.adyenStatus}`]
      : []),
    ...(diagnostic.upstreamStatus
      ? [`Adyen HTTP: ${diagnostic.upstreamStatus}`]
      : []),
    ...(diagnostic.adyenErrorCode
      ? [`Adyen-Fehlercode: ${diagnostic.adyenErrorCode}`]
      : []),
    ...(diagnostic.adyenRequestId
      ? [`Adyen-Request-ID: ${diagnostic.adyenRequestId}`]
      : []),
    `Laufzeit: ${diagnostic.durationMs} ms`,
  ];
}
